import { Controller } from '@hotwired/stimulus';
import {
  extend, isEmpty, isString, split, template,
} from 'lodash';

const MODAL_TEMPLATE = template(`
<div class="modal-dialog <%= modalClasses %> modal-form-wrapper">
  <div class="modal-content">
    <% if (title){ %>
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span></button>
        <h4 class="border-bottom modal-title"><%= title %></h4>
      </div>
    <% } %>
    <div class="modal-body">
    </div>
      <div class="modal-footer">
        <button data-btn-key='cancel' type='button' class='btn btn-default' data-dismiss="modal">Cancelar</button>
        <% _(controls).each(function(control){ %>
          <% if (control == 'save'){ %>
            <button data-btn-key='save' type='button' class='btn btn-cifra'>Guardar</button>
          <% }else if (control == 'save-continue'){ %>
            <div class='checkbox only-new pull-left'><label><input type='checkbox' id='save-continue'>Seguir añadiendo al guardar</label></div>
          <% }else if (control == 'delete'){ %>
            <a data-btn-key="delete" data-confirm="¿Está seguro de eliminar el elemento seleccionado?" class="btn btn-danger pull-left only-edit" data-remote="true" rel="nofollow" data-method="delete" href="#">Eliminar</a>
          <% } %>
        <% }); %>
      </div>
  </div>
</div>
`);

/*
La idea es que al cargar existe un formulario X. Esta vista mete el formulario en un modal,
controla el desacticonst el botón mientras hace submit, ocultar al terminar etc.

Hay varios controles predefinidos que se puede indicar:
{
  controls: ['save', 'save-continue', 'delete']
}
Si se puede borrar hay que indicar la URL en el parámetro deleteRootUrl.

Este objetos va lanzando eventos para poder conectarse desde fuera y hacer cosas
especiales según donde lo utilicenmos
*/
/* global Cifra, Mn, Backbone, $ */
// Lo dejamos como componente global porque se usa en registro_observaciones por ejemplo
Cifra.Components.ModalForm = Mn.View.extend({
  template: MODAL_TEMPLATE,
  className: 'modal fade',
  id() {
    // Es obligatiorio pasar un parámetro id (o en html data-id) con el id
    // que se pondrá al modal o sino este método peta
    return this.getOption('id');
  },
  ui: {
    submit: 'input[type=submit], [data-btn-key=save]',
    form: 'form',
  },
  events: {
    'ajax:success': 'success',
    'ajax:before': 'disableForm',
    'ajax:complete': 'enableForm',
    'delete:done': 'successDelete',
    'click [data-btn-key=save]': 'saveClicked',
    'show.bs.modal': '_beforeShowModal',
    'shown.bs.modal': '_afterShowModal',
  },
  modelEvents: {
    // eslint-disable-next-line quote-props
    'change': '_updateFormFields',
  },
  initialize(options) {
    if (!options.model) {
      this.model = new Backbone.Model({});
    }
    this._hideAfterSubmit = true;
    this._disabled = false;
  },
  getDeleteUrl() {
    return this.getOption('deleteRootUrl') + this.model.get('id');
  },
  templateContext() {
    let controls = this.getOption('controls');
    if (isString(controls)) {
      controls = split(controls, ' ');
    }
    return {
      modalClasses: this.getOption('modalClasses'),
      title: this.getOption('title'),
      footer: this.getOption('footer'),
      controls,
    };
  },
  render() {
    const $form = $(this.options.formSelector);
    $form.detach();
    Mn.View.prototype.render.call(this);
    this.$('.modal-body').append($form);
    this.$el.appendTo('body');
    this.bindUIElements();
    return this;
  },
  saveClicked(e) {
    if (this._disabled) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    const $continueCheck = this.$('#save-continue');
    const continuar = $continueCheck.length && $continueCheck.is(':visible') && $continueCheck.is(':checked');
    this._hideAfterSubmit = !continuar;
    this.submitForm();
  },
  success(_event, data, status, xhr) {
    this.model.clear({
      silent: true,
    }).set(Backbone.Syphon.serialize(this)[this.getOption('fieldContext')]);
    this.triggerMethod('form:success', data, status, xhr);
    if (this._hideAfterSubmit) {
      this.$el.modal('hide');
    }
    this.resetForm();
  },
  successDelete(_event, data, status, xhr) {
    this.$el.modal('hide');
    this.triggerMethod('form:success:delete', data, status, xhr);
    this.resetForm();
  },
  disableForm() {
    this._disabled = true;
    this.getUI('submit').attr('disabled', 'disabled');
  },
  enableForm() {
    this._disabled = false;
    this.getUI('submit').removeAttr('disabled');
  },
  resetForm(ignoreHidden) {
    // TODO: Usar Cifra.Utils.resetForm
    this.getUI('form').trigger('reset');
    // El reset no limpia los ocultos, nosotros por defecto sí
    if (ignoreHidden !== true) {
      // No limpiamos valores de los hidden de los checkbox, siempre tienen que tener el valor
      this.$('input[type=hidden]')
        .not('.checkbox > input[type=hidden]')
        // Internos de rails
        .not('input[name=_method]')
        .not('input[name=utf8]')
        .val('');
    }
    this._focusFirst();
    this.triggerMethod('form:reset');
    this.resetModel();
  },
  submitForm() {
    this.getUI('form').submit();
    return this;
  },
  resetModel() {
    this.setModelData({});
  },
  setModelData(data) {
    if (isEmpty(data)) {
      // hay que hacerlo así porque un set de data {} no lanza el evento change
      this.model.clear();
    } else {
      this.model.clear({
        silent: true,
      }).set(data);
    }
    return this;
  },
  show(data) {
    if (data !== undefined) {
      this.setModelData(data);
    }
    this.$el.modal('show');
    return this;
  },
  _beforeShowModal(e) {
    // El evento es show.bs.modal y jquery lo trata como namespace después del punto y va a lanzar
    // el evento show en todos los elementos. Aquí nos aseguramos que es el show del modal
    if (e.namespace === 'bs.modal') {
      // e.relatedTarget es el elemento que ha provocado la apertura del modal
      this.triggerMethod('before:show:modal', e.relatedTarget);
      this._checkButtonsVisibility();
    }
  },
  _afterShowModal() {
    this._focusFirst();
  },
  _updateFormFields() {
    const data = {};
    data[this.getOption('fieldContext')] = this.model.attributes;
    Backbone.Syphon.deserialize(this, data);
  },
  _checkButtonsVisibility() {
    const $botonBorrar = this.$('[data-method=delete]');
    const id = this.model.get('id');
    if (id) {
      $botonBorrar.attr('href', this.getDeleteUrl()).show();
      this.$('.only-edit').show();
      this.$('.only-new').hide();
    } else {
      this.$('.only-edit').hide();
      this.$('.only-new').show();
    }
  },
  _focusFirst() {
    this.getUI('form').find('*').filter(':input:visible:first').focus();
  },
});

/**
 * Componente excesivamente enrevesado, no usarlo
 * @deprecated
 */
export default class extends Controller {
  connect() {
    // Este componente es muy raro. La primera vez conecta todo pero mueve el formulario
    // a un modal y este modal lo mueve debajo del body. Al moverlo provoca que se vuelva
    // a llamar al conect del controlador pero nosotros ya le tenemos conectado
    if (this.element.closest('.modal-form-wrapper')) {
      return;
    }

    const options = extend({
      // OJO!!!!! que se le pasa el formulario
      formSelector: this.element,
    }, $(this.element).data());

    this.component = new Cifra.Components.ModalForm(options);
    this.component.render();
  }

  render() {
    this.component.render();
  }
}
